module.exports = __webpack_public_path__ + "img/luggage-03.edd5c58b.svg";